import { AppContext } from '@/contexts/AppContext';
import { useCommunity, useCommunityId } from '@/hooks/communities';
import { EnvironmentService } from '@/services/environment';
import { useEffect, useState, type FC, type PropsWithChildren } from 'react';

const { Provider } = AppContext;

export const AppContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const { data } = useCommunityId.useSuspenseQuery();
  const { data: community } = useCommunity.useSuspenseQuery(data?.communityId);
  const [tenantClientUrl, setTenantClientUrl] = useState(
    EnvironmentService.getTenantClientUrlSync(),
  );

  useEffect(() => {
    EnvironmentService.getTenantClientUrl().then(setTenantClientUrl);
  }, []);

  if (!community) {
    return null;
  }

  return <Provider value={{ community, tenantClientUrl }}>{children}</Provider>;
};
